import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function DocIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0)">
				<path d="M5 24H20C21.1046 24 22 23.1046 22 22V7.04643C22 6.05136 21.6291 5.09202 20.9598 4.35574L18.1903 1.30931C17.4322 0.475411 16.3575 0 15.2305 0H5C3.89543 0 3 0.89543 3 2V22C3 23.1046 3.89543 24 5 24Z" fill={props.fill} />
				<path opacity="0.5" d="M15 0V5C15 6.10457 15.8954 7 17 7H22" stroke="white" strokeWidth="2" strokeLinecap="round" />
				<mask id="path-3-inside-1" fill="white">
					<path d="M9 11C9 10.4477 9.44772 10 10 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H10C9.44772 12 9 11.5523 9 11Z" />
				</mask>
				<path d="M9 11C9 10.4477 9.44772 10 10 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H10C9.44772 12 9 11.5523 9 11Z" fill={props.fill} />
				<path d="M10 11H15V9H10V11ZM15 11H10V13H15V11ZM10 11H10H8C8 12.1046 8.89543 13 10 13V11ZM15 11V13C16.1046 13 17 12.1046 17 11H15ZM15 11H17C17 9.89543 16.1046 9 15 9V11ZM10 9C8.89543 9 8 9.89543 8 11H10V9Z" fill="white" mask="url(#path-3-inside-1)" />
				<mask id="path-5-inside-2" fill="white">
					<path d="M9 15C9 14.4477 9.44772 14 10 14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H10C9.44772 16 9 15.5523 9 15Z" />
				</mask>
				<path d="M9 15C9 14.4477 9.44772 14 10 14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H10C9.44772 16 9 15.5523 9 15Z" fill={props.fill} />
				<path d="M10 15H11V13H10V15ZM11 15H10V17H11V15ZM10 15H10H8C8 16.1046 8.89543 17 10 17V15ZM11 15V17C12.1046 17 13 16.1046 13 15H11ZM11 15H13C13 13.8954 12.1046 13 11 13V15ZM10 13C8.89543 13 8 13.8954 8 15H10V13Z" fill="white" mask="url(#path-5-inside-2)" />
			</g>
			<defs>
				<clipPath id="clip0">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>

	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<DocIcon fill={props.fill} />
		</div>
	);
}